<div class="ejercicio-asociados">
    <div class="panel">
        <div class="toolbar">
            <div class="toolbar-wide">
                <label class="form-label" for="ej-busqueda">Buscar</label>
                <div class="search-field">
                    <i class="bi bi-search" aria-hidden="true"></i>
                    <input id="ej-busqueda" type="search" class="form-control" data-testid="busqueda" autocomplete="off" placeholder="Nombre, apellidos o DNI/NIF" [formControl]="busqueda">
                </div>
            </div>
            <div>
                <label class="form-label" for="ej-asociacion">Asociación</label>
                <select id="ej-asociacion" class="form-select" data-testid="filtro-asociacion" [(ngModel)]="asociacion" (ngModelChange)="reiniciar()">
                    <option value="">Todas</option>
                    @for (a of asociaciones; track a.id) { <option [ngValue]="a.id">{{ a.nombre }}</option> }
                </select>
            </div>
            <div>
                <label class="form-label" for="ej-cargo">Cargo</label>
                <select id="ej-cargo" class="form-select" data-testid="filtro-cargo" [(ngModel)]="cargo" (ngModelChange)="reiniciar()">
                    <option value="">Todos</option>
                    @for (c of cargos; track c.id) { <option [ngValue]="c.id">{{ c.nombre }}{{ c.esInfantil ? ' (infantil)' : '' }}</option> }
                </select>
            </div>
            <div>
                <label class="form-label" for="ej-tipo">Tipo</label>
                <select id="ej-tipo" class="form-select" data-testid="filtro-tipo" [(ngModel)]="tipo" (ngModelChange)="reiniciar()">
                    <option value="">Todos</option>
                    @for (t of TIPOS; track t.id) { <option [ngValue]="t.id">{{ t.texto }}</option> }
                </select>
            </div>
            <div>
                <label class="form-label" for="ej-estado">Estado</label>
                <select id="ej-estado" class="form-select" data-testid="filtro-estado" [(ngModel)]="estado" (ngModelChange)="reiniciar()">
                    <option value="todos">Todos</option>
                    <option value="vigentes">Vigentes</option>
                    <option value="bajas">Bajas</option>
                </select>
            </div>
            <div>
                <label class="form-label" for="ej-tamano">Por página</label>
                <select id="ej-tamano" class="form-select" data-testid="tamano-pagina" [(ngModel)]="pageSize" (ngModelChange)="reiniciar()">
                    @for (t of TAMANOS; track t) { <option [ngValue]="t">{{ t }}</option> }
                </select>
            </div>
        </div>
    </div>

    <div class="toolbar-summary">
        <p aria-live="polite" data-testid="resumen">
            @if (cargando) { Buscando… } @else if (resultado) {
                @if (total) { <strong>{{ total }}</strong> asociado(s) · mostrando {{ desde }}–{{ hasta }} } @else { 0 asociados }
            }
        </p>
        @if (hayFiltros) { <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="limpiar" (click)="limpiarFiltros()"><i class="bi bi-x-circle" aria-hidden="true"></i>Limpiar filtros</button> }
    </div>

    @if (error) {
        <div class="state-panel state-panel--error mb-3" role="alert" data-testid="error">
            <i class="bi bi-wifi-off state-panel__icon" aria-hidden="true"></i>
            <p class="state-panel__text">{{ error }}</p>
            <button type="button" class="btn btn-outline-danger btn-sm" data-testid="reintentar" (click)="reintentar()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button>
        </div>
    }

    <div class="results-area">
        @if (cargando) {
            <div class="progress results-progress" role="progressbar" aria-label="Cargando" data-testid="cargando">
                <div class="progress-bar progress-bar-striped progress-bar-animated w-100"></div>
            </div>
        }
        <div class="cards-grid" [class.is-loading]="cargando" data-testid="tarjetas">
            @for (a of resultado?.asociados ?? []; track a.id) {
                <div class="card-with-notes" data-testid="tarjeta">
                    <app-item [type]="ItemType.ASOCIADOS" [item]="a" [soloIdentidad]="true"></app-item>
                    @if (a.relaciones.length) {
                        <p class="card-notes" data-testid="relaciones">
                            @for (r of a.relaciones; track $index) { <span class="d-block text-truncate">{{ r.cargo }} · {{ r.nombreAsociacion }}@if (r.estado === 'baja') { (baja) }</span> }
                            @if (a.totalRelaciones > a.relaciones.length) { <span class="d-block">y {{ a.totalRelaciones - a.relaciones.length }} más</span> }
                        </p>
                    }
                </div>
            }
        </div>
        @if (!(resultado?.asociados?.length) && !cargando && !error) {
            <div class="state-panel" role="status" data-testid="sin-resultados">
                <i class="bi bi-person-x state-panel__icon" aria-hidden="true"></i>
                <p class="state-panel__title">No hay asociados en este ejercicio@if (hayFiltros) { con esos criterios }.</p>
            </div>
        }
    </div>

    @if (totalPaginas > 1) {
        <nav class="pager" aria-label="Paginación de asociados del ejercicio">
            <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="anterior" [disabled]="pagina <= 1 || cargando" (click)="irA(pagina - 1)"><i class="bi bi-chevron-left" aria-hidden="true"></i>Anterior</button>
            <span data-testid="pagina">Página {{ pagina }} de {{ totalPaginas }}</span>
            <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="siguiente" [disabled]="pagina >= totalPaginas || cargando" (click)="irA(pagina + 1)">Siguiente<i class="bi bi-chevron-right" aria-hidden="true"></i></button>
        </nav>
    }
</div>
